import { kpiApi } from "@/api/kpiApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import { Container, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function KpiCreateNewLayout(props) {
    const getKpiOptions = kpiApi.endpoints.getKpiOptions.useQuery();
    const kpiOptions = getKpiOptions.data?.data;
    const isLoading = getKpiOptions.isLoading;

    return (
        <>
            <Container>
                <Breadcrumbs items={[{ label: "KPIs", to: "/workspace/kpis" }, { label: "New" }]} />
            </Container>

            <Container>
                <Typography variant="h1" gutterBottom sx={{ fontWeight: "bold", fontSize: 34 }}>
                    สร้างตัวชี้วัด
                </Typography>
            </Container>

            {/** content */}
            {isLoading ? <Loading /> : <Outlet context={{ kpiOptions }} />}
        </>
    );
}
